<template>
<div>
  <div>
    <div v-if="error" class="alert alert-warning text-center" role="alert">
      Please complete all required fields marked with (*)
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-6 col-lg-6">
        <div class="form-group">
          <label for="companyName">Company Name *</label>
          <input type="text" @select="helpSection()" v-model="form.companyName" class="form-control" id="companyName" name="companyName">
        </div>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-6">
        <div class="form-group">
          <label for="companyLocation">Company Location *</label>
          <input type="text" @select="helpSection()" v-model="form.companyLocation" class="form-control" id="companyLocation" name="companyLocation">
        </div>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-12">
        <div class="form-group">
          <label for="jobTitle">Job Title *</label>
          <input type="text" @select="helpSection()" v-model="form.jobTitle" class="form-control" id="jobTitle" name="jobTitle">
        </div>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-12">
        <div class="form-group">
          <label for="jobDuties">Job Duties *</label>
          <div class="float-right" v-if="dutiesWordCount < 41">Word Count: {{ dutiesWordCount }}</div>
          <div class="float-right text-danger" v-else>Word Count: {{ dutiesWordCount }}</div>
          <div v-if="dutiesWordCount > 40" class="text-primary float-left"><i class="fas fa-info-circle"></i> It's recommended to keep this field to 40 words or less.</div>
          <textarea @select="helpSection()" @input="wordCountDuties()" v-model="form.jobDuties" class="form-control" id="jobDuties" name="jobDuties"></textarea>
        </div>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-6">
        <div class="form-group">
          <label for="companyStartDate">Start date *</label>
          <input type="text" @select="helpSection()" v-model="form.companyStartDate" class="form-control" id="companyStartDate" name="companyStartDate">
        </div>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-6">
        <div class="form-group">
          <label for="companyEndDate">End date *</label>
          <input type="text" @select="helpSection()" v-model="form.companyEndDate" class="form-control" id="companyEndDate" name="companyEndDate">
        </div>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-12" v-if="form.jobAccomplishments.length <= accomplishmentLimit">
        <label for="jobAccomplishments">Job Accomplishments</label>
        <div class="input-group mb-3">
          <input type="text" @select="helpSection()" class="form-control" v-model="newAccomplishment" placeholder="" aria-label="" id="jobAccomplishments" name="jobAccomplishments">
          <div class="input-group-append">
            <button class="btn btn-primary" @click.prevent="addAccomplishment()" type="button" id="button-addon2"><i class="fas fa-plus-circle"></i> Add</button>
          </div>
        </div>
        <div v-if="accomplishmentError" class="alert alert-warning text-center" role="alert">
          This accomplishment already exists.
        </div>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-12" v-if="form.jobAccomplishments.length > 0">
        <div class="mb-2" v-if="form.jobAccomplishments.length > 0">Click on an accomplishment to edit</div>
        <ul class="list-group" v-for="(accomplishment, n) in this.form.jobAccomplishments" :key="accomplishment.id">
          <li class="list-group-item mb-1"><span style="cursor:pointer;" data-toggle="modal" data-target="#editAccomplishment" @click.prevent="loadAccomplishment(n)">{{ accomplishment.value }}</span> <a class="float-right text-danger pl-2" href="#!" @click.prevent="removeAccomplishment(n)"><i class="fas fa-trash-alt"></i></a></li>
        </ul>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-12 text-center">
        <div class="form-group">
          <a href="" @select="helpSection()" @click.prevent="storeData()" class="btn btn-lg btn-secondary btn-block">Add Record <i class="far fa-hand-point-right"></i></a>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="editAccomplishment" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit Accomplishment</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <label for="accomplishmentEdit">Replace with new value</label>
          <input id="accomplishmentEdit" class="form-control" type="text" v-model="editAccomplishmentValue">
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-danger" data-dismiss="modal">Cancel</button>
          <button @click.prevent="updateAccomplishment()" type="button" class="btn btn-success" data-dismiss="modal" aria-label="Close">Save</button>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'employmentHistory',
  components: {

  },
  props: ['employeerId'],
  data() {
    return {
      error: false,
      accomplishmentLimit: 4,
      newAccomplishment: '',
      accomplishmentError: false,
      dutiesWordCount: 0,
      editAccomplishmentValue: '',
      editAccomplishmentPosition: '',
      form: {
        companyName: "",
        companyStartDate: "",
        companyEndDate: "",
        companyLocation: "",
        jobTitle: "",
        jobDuties: "",
        jobAccomplishments: [],
      }
    }
  },
  methods: {
    addAccomplishment() {
      // ensure they actually typed something
      if (!this.newAccomplishment) {
        return;
      }

      var accomplishment_values = []
      var accomplishment;
      for(accomplishment in this.form.jobAccomplishments) {
        var value = this.form.jobAccomplishments[accomplishment].value;
        accomplishment_values.push(value);
      }

      var search = accomplishment_values.indexOf(this.newAccomplishment);

      if (search == -1) {
        this.form.jobAccomplishments.push({
          "id": Math.round(Math.random() * 1000000),
          "value": this.newAccomplishment
        });
        this.newAccomplishment = '';
        this.accomplishmentError = false;
      } else {
        this.accomplishmentError = true;
      }
    },

    removeAccomplishment(x) {
      this.form.jobAccomplishments.splice(x, 1);
    },

    loadAccomplishment(x) {
      this.editAccomplishmentValue = this.form.jobAccomplishments[x].value;
      this.editAccomplishmentPosition = x;
    },

    updateAccomplishment() {
      this.form.jobAccomplishments[this.editAccomplishmentPosition].value = this.editAccomplishmentValue;
      this.editAccomplishmentValue = '';
      this.editAccomplishmentPosition = '';
    },

    removeEmployeer(x) {
      this.$emit('removeEmployeer', x);
    },

    helpSection() {
      this.$emit('loadHelpSection', "employment");
    },

    wordCountDuties() {
      var count = this.form.jobDuties.trim().split(" ").length;
      this.dutiesWordCount = count;
    },

    storeData() {

      if(this.newAccomplishment)
      {
        this.addAccomplishment()
      }

      if (!this.form.companyName ||
        !this.form.companyStartDate ||
        !this.form.companyLocation ||
        !this.form.jobTitle ||
        !this.form.jobDuties) {
        this.error = true;
        return;
      }

      this.$emit('storeData', this.form);
      this.form.companyName = "";
      this.form.companyStartDate = "";
      this.form.companyEndDate = "";
      this.form.companyLocation = "";
      this.form.jobTitle = "";
      this.form.jobDuties = "";
      this.form.jobAccomplishments = [];
      this.dutiesWordCount = 0;
      this.error = false;
    }
  }
}
</script>

<style>

</style>
